import * as React from "react";
import { AppBar, Box, Stack, IconButton } from "@mui/material";
import Logo from "../../assets/vepay-logo-full.svg";
import OnBoardingSteps from "./OnBoardingSteps";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";

export default function Onboarding() {
  const [activeStep, setActiveStep] = React.useState(0);
  const navigate = useNavigate();

  return (
    <Box sx={{ flexGrow: 1, background: "#F9F9FB", minHeight: "100vh" }}>
      <AppBar position="static">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mx: 2, my: 1 }}
        >
          {activeStep === 0 ? (
            <IconButton
              onClick={() => navigate("/login")}
              sx={{ color: "white" }}
            >
              <ArrowBackIosNewIcon />
            </IconButton>
          ) : (
            <Box sx={{ width: 40 }} />
          )}

          <img src={Logo} alt="VePay" style={{ width: "250px" }} />

          <Box sx={{ width: 40 }} />
        </Stack>
      </AppBar>
      <OnBoardingSteps onStepChange={setActiveStep} />
    </Box>
  );
}
